import { render } from "./selectTax.vue?vue&type=template&id=8cf7bb10"
import script from "./selectTax.vue?vue&type=script&lang=js"
export * from "./selectTax.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__